<ng-container *ngIf="vm$ | async as vm">
  <split-card theme="secondary">
    <ng-container card-header>
      <div class="shipping-accounting-toolbar">
        <split-group-filter id="shippingAccountingFilter" (onFilterEvent)="onFilter($event)">
          <split-filter-month
            [required]="true"
            [data]="listData"
            groupId="shippingAccountingFilter"
            field="month"
            label="Mês"
            key="month">
          </split-filter-month>
          <split-filter-professional
            groupId="shippingAccountingFilter"
            field="professional"
            label="Profissional"
            key="professional">
          </split-filter-professional>
        </split-group-filter>
      </div>
    </ng-container>
  </split-card>

  <split-loading-placeholder *ngIf="vm.state === 'loading'" [count]="3"></split-loading-placeholder>

  <!--<div *ngIf="vm.state === 'error'" class="shipping-accounting-state shipping-accounting-state--error" role="alert">
    <split-icon name="alert-circle" size="22"></split-icon>
    <span>{{ vm.errorMessage }}</span>
  </div>-->

  <div *ngIf="vm.state === 'empty'" class="shipping-accounting-state">
    <split-icon name="search" size="24"></split-icon>
    <span>Nenhum resultado encontrado.</span>
  </div>

  <app-shipping-accounting-list
    *ngIf="vm.state === 'success' || vm.state === 'error'"
    [items]="vm.items"
    [downloadingCsvFor]="vm.downloadingCsvFor"
    (downloadCsvClick)="onDownloadCsv($event)"
    (sendEmailClick)="onSendEmailClick($event)">
  </app-shipping-accounting-list>

  <split-loading-placeholder *ngIf="vm.loadingMore" [count]="2"></split-loading-placeholder>

  <div *ngIf="vm.state === 'success' || vm.state === 'error'"
       splitInfiniteScroll
       [splitInfiniteScrollDisabled]="!vm.hasMore || vm.loadingMore"
       (scrolled)="onLoadMore()"
       class="sa-scroll-sentinel">
  </div>

  <app-shipping-accounting-send-modal
    [item]="selectedForEmail"
    [dateRange]="vm.dateRange"
    [sending]="vm.sendingEmail"
    (submitted)="onEmailSubmit($event)"
    (cancel)="onEmailCancel()">
  </app-shipping-accounting-send-modal>
</ng-container>
